export class ZaitakuSyncItem {
    countflg: boolean = true;     
    hasSocialLicense: boolean = false;         
    hasAllRehabProfessionals: boolean = false;         
    isRehabQualified: boolean = false;         
    isRehab20Min: boolean = false;         
    isRehab3PerWeek: boolean = false;         
    date: string = "";                // 識別1
    dayInMonth: number = 0;           // 識別2
    cumulativeDays: number = 0;       // 識別3
    inmates: number = 0;              // 識別4
    cumulativeNew: number = 0;        // 識別5
    newLeavers: number = 0;           // 識別6
    peopleLeaving: number = 0;        // 識別7
    death: number = 0;                // 識別8
    admission: number = 0;            // 識別9
    discharge: number = 0;            // 識別10
    serviceType: number = 0;          // 識別11
    healthFacility: number = 0;       // 識別12
    physicalTherapists: number = 0;   // 識別13
    careHealthFacility: number = 0;   // 識別14
    coumselors: number = 0;           // 識別15
    aspiration: number = 0;           // 識別16
    feeding: number = 0;              // 識別17
    sameDayDischarge45: number = 0;
    sameDayDischarge: number = 0;
    sameDayAdmissionDischarge45: number = 0;
    sameDayAdmissionDischarge: number = 0;
    [key: string]: any; 
  };


  export class ZaitakuDatatableDetailItem {      
    date: string = "";                // 識別1

    cumulativeNew:  any[] = [];        // 識別5
    newLeavers:  any[] = [];           // 識別6
    peopleLeaving:any[] = [];        // 識別7
    death: any[] = [];                // 識別8

    admission: any[] = [];            // 識別9
    discharge: any[] = [];            // 識別10
    aspiration: any[];           // 識別16
    feeding: any[];              // 識別17
    inmatesDbl: any[] = [];
  };